export const blockIconsDeviceGppGood = (
	<span className='material-symbols-outlined'>gpp_good</span>
);
